<template>
  <div>
    <div class="card">

      <!-- <Toast position="bottom-right" /> -->
      

      <h4>System Training Videos</h4>
      <Toolbar class="p-mb-4">
        <template slot="left">
          <span class="p-input-icon-left">
            <div class="p-inputgroup">
              <Button
                label="Refresh"
                icon="pi pi-fw pi-refresh"
                class="p-mr-1"
                @click="setupComponentData(1)"
              />
              <InputText
                v-model="searchText"
                placeholder="Global Search"
                @input="updateSearch"
              />
              <Button
                icon="pi pi-times p-pr-1"
                class="p-mr-1"
                @click="closeSearch"
              />
            </div>
          </span>
        </template>
        <template slot="right">
        </template>
      </Toolbar>

    </div>
      
    <VidoesTable
      :searchText="searchText"
      :videosData="videosData"
      :loading="requestingVideos"
      @openVideo="openVideo"
    />

    <VideoDialog
      :video="selectedVideo"
      :videoDialog="videoDialog"
      @close="videoDialog = false"
    />
  </div>
</template>

<script>
import UserService from '../../service/UserService'

import VidoesTable from '../universalComponents/videos/VideosTable.vue'
import VideoDialog from '../universalComponents/videos/VideoDialog.vue'

export default {
  components: {
    VidoesTable,
    VideoDialog
  },
  userService: null,
  created() {
    

    this.userService = new UserService();

    this.setupComponentData(0)
  },
  data: function() {
    return {
      searchText: '',
      videoDialog: false,
      selectedVideo: {}
    }
  },
  computed: {
    requestingVideos() {
      return this.$store.getters.getRequestingVideos
    },
    videosData() {
      return this.$store.getters.getVideosData
    },
  },
  methods: {
    setupComponentData(hardLoad) {
      if (hardLoad) {
        this.getVideos()
      } else {
        if (!(this.videosData && this.videosData.length)) {
          this.getVideos()
        }
      }
    },
    openVideo(videoData) {
      if (videoData && videoData.url) {
        this.selectedVideo = videoData
        this.videoDialog = true
      }
    },
    getVideos() {
      this.$store.dispatch('setVideosData', [])
      this.$store.dispatch('setRequestingVideos', true)

      this.userService
        .getHelpVideos()
        .then(data => {
          this.$store.dispatch('setRequestingVideos', false)
          this.$store.dispatch('setVideosData', data)
        })
        .catch(error => {
          // 
          this.$store.dispatch('setRequestingVideos', false)
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "helpVideos"'
          })
        })
    },
    closeSearch () {
      this.searchText = ''
      this.$router.push({ query: { search: '' } });
    },
    updateSearch(e) {
      this.searchText = e
      this.$router.push({ query: { search: e } });
    }
  }
}
</script>

<style>

</style>